import { AccountType } from '@mecontrol/public-api';
import { EventParams, PageName, ContentSource } from "@mecontrol/common";
import { getCv, perfNow, guid } from '../utilities';

export interface EventMoment {
    cv: string;
    impressionGuid: string;
    pageName: PageName;
    date: Date;
    timestamp: number;
    accounts: {
        counts: string;
        current?: AccountType;
    };
}
export type QueuedEvent = [EventParams, EventMoment];

// Queue state
const impressionGuid = guid();
let eventsQueue: QueuedEvent[] = [];
let pageName = PageName.null;
let accounts: EventMoment['accounts'] = {
    counts: '0-0'
};

/** Queue an event for processing later */
export function queueEvent(params: EventParams): void {
    eventsQueue.push([params, captureMoment(params)]);
}

export function popEvents(type: string): QueuedEvent[] {
    let newQueue: QueuedEvent[] = [];
    let poppedEvents: QueuedEvent[] = [];
    for (let i = 0; i < eventsQueue.length; i++) {
        if (eventsQueue[i][0].eventType === type) {
            poppedEvents.push(eventsQueue[i]);
        }
        else {
            newQueue.push(eventsQueue[i]);
        }
    }
    eventsQueue = newQueue;
    return poppedEvents;
}

/** Create an EventMoment to capture information about when the event happened */
export function captureMoment(params: EventParams): EventMoment {
    // All events increment the CV
    let cv = getCv();
    cv.increment();

    // Some events may update the page name
    // Specifically: ContentUpdate
    if (params.eventType === 'ContentUpdate' && params.content && params.content.source === ContentSource.UX) {
        pageName = params.content.id as PageName;
    }

    return {
        cv: cv.getValue(),
        impressionGuid,
        pageName,
        date: new Date(),
        timestamp: perfNow(),
        accounts
    };
}

/**
 * Set the current template of active and remembered accounts currently
 * on display in the control
 * @param activeAccountType Type of the currently active account (if any)
 * @param totalAccounts Number of accounts the control is aware of
 */
export function updateMoment(activeAccountType: AccountType | undefined, totalAccounts: number): void {
    const activeAccounts = activeAccountType ? 1 : 0;
    const otherAccounts = totalAccounts - activeAccounts;
    accounts.counts = `${activeAccounts}-${otherAccounts}`;
    accounts.current = activeAccountType;
}

/**
 * returns the type of the current account
 */
 export function getCurrentAccountType(): AccountType | undefined{
    return accounts.current;
}

/** FOR TESTING ONLY. Empties the queue of events */
export const clearQueue = () => { eventsQueue = []; };
